/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentState {
    Open = 0,
    Closed = 1,
}